<div class="container">
    <loading-overlay [show]="true">
      <div class="row" style="margin-top: 5%">
        <div class="col-sm-3">
        </div>
        <div class="col-sm-6">
            <div class="card text-center">
                <div class="card-body">
                  <h1 class="card-title" style="font-size: large; font-weight:600; margin-bottom: 12px;">FBI-Dashboard</h1>
                  <div class="panel-body panel-mega-form" style="text-align: center;">
                    <h4>Cargando...</h4>
                    <h4>Por favor, espere</h4>
                  </div>
                </div>
            </div>
        </div>
        <div class="col-sm-3">
        </div>
    </div>
    </loading-overlay>
  </div>
  